import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import { GetSingleRecipe } from "../../../../APIs/Function/Workout/Recipe/GetSIngleRecipe";
import CustomButton from "../../../../Components/Button/CustomButton";

const SingleRecipe = () => {
  const [singleRecipe, setSingleRecipe] = useState({});
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const handleSingleRecipe = async () => {
    try {
      setLoading(true);
      let res = await GetSingleRecipe(id);
      setSingleRecipe(res.r);

      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  console.log(singleRecipe);
  useEffect(() => {
    handleSingleRecipe();
  }, []);
  console.log(singleRecipe);

  return (
    <>
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <CircularProgress></CircularProgress>
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={"/recipeplans"}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img height={"100%"} src={backbluebtn} alt="back" />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Details
              </Typography>
            </Box>
            <Box>
              <Link to={`/Editrecipeplans/${singleRecipe.id}`}>
                <CustomButton
                  sx={{
                    width: { xs: "40px", md: "50px", lg: "80px" },
                    height: { xs: "10px", md: "50px", lg: "50px " },
                  }}
                >
                  Edit
                </CustomButton>
              </Link>
            </Box>
          </Box>

          <Box sx={{ p: 3, display: "flex", boxSizing: "border-box" }}>
            <Box
              sx={{
                textAlign: "center",
                height: "65%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                boxSizing: "border-box",
                border: "1px solid #E8E8E8",
                borderRadius: "5px",
                p: "15px",
                width: "50%",
              }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  width: "100%",
                  fontFamily: "Inter",
                  fontSize: "20px",
                }}
              >
                Banner Image
              </Typography>
              <Box
                sx={{
                  m: "auto",
                  mt: "10px",
                  height: "90%",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  overflow: "hidden",
                  borderRadius: "5px",
                }}
              >
                <img
                  width={"100%"}
                  height={"100%"}
                  style={{ objectFit: "cover", width: "100%", height: "100%" }}
                  src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${
                    singleRecipe?.recipe_images &&
                    singleRecipe?.recipe_images[0].r_images
                  }`}
                  alt=""
                />
              </Box>
            </Box>
            <Box sx={{ boxSizing:"border-box",width:'50%',ml:3,}}>
              <Box
                sx={{
                  border: "1px solid #E8E8E8",
                  textAlign: "left",
                  boxSizing: "border-box",
                  p: "10px",
                  borderRadius: "5px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "17px",
                    color: "#737373",
                  }}
                >
                  Title
                </Typography>
                <Typography sx={{ fontFamily: "Open Sans", fontSize: "17px" }}>
                  {singleRecipe.title}
                </Typography>
              </Box>
              <Box
                sx={{
                  border: "1px solid #E8E8E8",
                  mt: "10px",
                  textAlign: "left",
                  boxSizing: "border-box",
                  p: "10px",
                  borderRadius: "5px",
                  height:'150px',
                  overflow:"auto"
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "17px",
                    color: "#737373",
                  }}
                >
                  Description
                </Typography>
                <Typography sx={{ fontFamily: "Open Sans", fontSize: "17px" }}  >
                  {singleRecipe.description}
                </Typography>
              </Box>
              <Box
                sx={{
                  border: "1px solid #E8E8E8",
                  mt: "10px",
                  textAlign: "left",
                  boxSizing: "border-box",
                  p: "10px",
                  borderRadius: "5px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "17px",
                    color: "#737373",
                  }}
                >
                  Recipe Type
                </Typography>
                <Typography sx={{ fontFamily: "Open Sans", fontSize: "17px" }}>
                  {singleRecipe.recipe_type}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default SingleRecipe;
